import { render } from "./Table.vue?vue&type=template&id=1d2c60ea&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1d2c60ea"

export default script